<template>
  <div class="sgf-app-shell-atom" v-sgf-theme>
    <svg width="0" height="0" style="display: none">
      <symbol id="warning" viewBox="0 0 32 32">
        <path
          d="M12.2 4.6 2 22.4C.3 25.3 2.4 29 5.8 29h20.6c3.4 0 5.5-3.6 3.8-6.6L19.8 4.6c-1.7-2.9-5.9-2.9-7.6 0z"
          fill="var(--sgf-c-fill)"
          stroke="currentColor"
          stroke-width="2.8"
        />
        <path fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" d="M16 10v8.6" />
        <circle fill="currentColor" stroke="currentColor" cx="15.9" cy="23.8" r="1.4" />
      </symbol>
      <symbol id="info" viewBox="0 0 32 32">
        <circle cx="16.2" cy="16" r="14.6" fill="var(--sgf-c-fill)" stroke="currentColor" stroke-width="2.8" stroke-miterlimit="10" />
        <path fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" d="M15.9 7.8v10.4" />
        <circle cx="15.9" cy="24.1" r="1.4" fill="currentColor" stroke="currentColor" />
      </symbol>
      <symbol id="arrow-down" viewBox="0 0 32 32">
        <path fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" d="m10.4 12.8 5.6 5.6 5.5-5.6" />
      </symbol>
      <symbol id="loader-primary" viewBox="0 0 46 46">
        <g fill="none" stroke="currentColor" stroke-width="5">
          <path stroke-linecap="round" d="M 23 3 A 20 20 45 0 1 43 23" />
          <path stroke-linecap="round" d="M 23 43 A 20 20 45 0 1 3 23" />
        </g>
      </symbol>
      <symbol id="cross" viewBox="0 0 32 32">
        <path style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="m1.4 1.4 29.2 29.2M30.6 1.4 1.4 30.6" />
      </symbol>
      <symbol id="circle" viewBox="0 0 32 32">
        <path stroke="currentColor" d="M16 26c-5.525 0-10-4.475-10-10S10.475 6 16 6s10 4.475 10 10-4.475 10-10 10z" />
      </symbol>
      <symbol id="calendar" viewBox="0 0 32 35.2">
        <g id="Group_776" transform="translate(-64.242 -150.501)">
          <path id="Line_325" style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="M74.1 151.9v5.3" />
          <path id="Line_326" style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="M86.1 151.9v5.3" />
          <path
            id="Path_261"
            d="M89.9 154.6H70.8c-2.4 0-4.4 1.9-4.5 4.3v20.7c0 2.3 1.8 4.3 4.2 4.3h.3c4.9-.5 19.1-4.3 19.1-4.3 2.4-.7 4.5-2.7 4.5-6.3v-14.4c0-2.5-2-4.4-4.5-4.3z"
            fill="none"
            stroke="currentColor"
            stroke-width="2.8"
          />
          <path id="Line_327" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-miterlimit="10" d="M67 164.3h26.9" />
          <path id="Line_328" style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="M72 170.6h.9" />
          <path id="Line_329" style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="M72 176.3h.9" />
          <path id="Line_330" style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="M79.7 170.6h.9" />
          <path id="Line_331" style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="M79.7 176.3h.9" />
          <path id="Line_332" style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round" d="M87.4 170.6h1" />
        </g>
      </symbol>
      <symbol id="round-check" viewBox="0 0 32 32">
        <g>
          <g>
            <path
              d="M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0Zm0 29.94C8.31 29.94 2.06 23.69 2.06 16S8.31 2.06 16 2.06 29.94 8.31 29.94 16 23.69 29.94 16 29.94Z"
              fill="currentColor"
            />
            <path
              d="M22.89 9.23 13.7 21.1l-4.71-4.39c-.42-.39-1.06-.36-1.46.05-.39.41-.36 1.07.05 1.45l6.36 5.94 10.57-13.66c.35-.45.27-1.1-.18-1.44-.45-.35-1.1-.27-1.45.19Z"
              fill="currentColor"
            />
          </g>
        </g>
      </symbol>
      <symbol id="payandplay" viewBox="0 0 33 20">
        <path
          d="M.75 4A3.25 3.25 0 0 1 4 .75h25A3.25 3.25 0 0 1 32.25 4v12.341c0 1.417-1.303 2.508-2.726 2.271-3.507-.584-8.934-1.362-13.024-1.362s-9.517.778-13.024 1.362C2.053 18.85.75 17.758.75 16.342V4Z"
          fill="#eff4ff"
          stroke="#046294"
          stroke-width="1.5"
        />
        <path
          d="M8.72 13H7.136V4.888H9.98c.944 0 1.664.224 2.16.672.504.44.756 1.076.756 1.908 0 .824-.252 1.46-.756 1.908-.496.44-1.216.66-2.16.66H8.72V13Zm1.14-4.248c.496 0 .852-.108 1.068-.324.224-.224.336-.544.336-.96 0-.856-.468-1.284-1.404-1.284H8.72v2.568h1.14Zm9.748 4.158V13h-1.36l-.7-.77a3.61 3.61 0 0 1-.93.65 2.7 2.7 0 0 1-1.14.23c-.587 0-1.053-.15-1.4-.45-.34-.307-.51-.7-.51-1.18 0-.42.123-.777.37-1.07.253-.293.59-.587 1.01-.88l.08-.06-.11-.12-.28-.29a2.455 2.455 0 0 1-.41-.6 1.463 1.463 0 0 1-.16-.64c0-.307.077-.59.23-.85.16-.26.39-.463.69-.61.3-.153.65-.23 1.05-.23.366 0 .693.077.98.23.293.153.52.36.68.62.16.253.24.533.24.84 0 .32-.107.613-.32.88-.207.267-.517.557-.93.87l-.12.08.91.98.11-.15.82-1.11.85.64-.84 1.15-.19.27 1.38 1.48Zm-3.75-4.02.16-.11c.273-.207.47-.377.59-.51a.655.655 0 0 0 .18-.45c0-.18-.07-.337-.21-.47a.751.751 0 0 0-.54-.2c-.247 0-.447.067-.6.2a.616.616 0 0 0-.22.47c0 .16.043.313.13.46.093.147.23.313.41.5l.1.11Zm-.38 3.2c.26 0 .497-.057.71-.17.22-.113.43-.273.63-.48l-1.08-1.19-.15.1c-.04.033-.153.12-.34.26-.187.14-.323.277-.41.41a.804.804 0 0 0-.12.42c0 .187.073.343.22.47.146.12.326.18.54.18Zm6.652.91h-1.584V4.888h2.844c.944 0 1.664.224 2.16.672.504.44.756 1.076.756 1.908 0 .824-.252 1.46-.756 1.908-.496.44-1.216.66-2.16.66h-1.26V13Zm1.14-4.248c.496 0 .852-.108 1.068-.324.224-.224.336-.544.336-.96 0-.856-.468-1.284-1.404-1.284h-1.14v2.568h1.14Z"
          fill="#046294"
        />
      </symbol>
      <symbol id="flexbanner" viewBox="0 0 16 17">
        <path
          d="M0 0H16V15.557C16 16.2552 15.3026 16.7385 14.6489 16.4933L8.35112 14.1317C8.12474 14.0468 7.87526 14.0468 7.64888 14.1317L1.35112 16.4933C0.697372 16.7385 0 16.2552 0 15.557V0Z"
          fill="currentColor"
        />
      </symbol>
      <symbol id="empty" viewBox="0 0 20 20">
        <path
          fill="currentColor"
          stroke="none"
          d="M14 14v-1c0-.55.45-1 1-1h3v5c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5h3c.55 0 1 .45 1 1v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2Zm-2-2v2H8v-2c0-1.1-.9-2-2-2H2l1.6-8h12.8l1.6 8h-4c-1.1 0-2 .9-2 2Zm8-2L18.16.8c-.09-.47-.5-.8-.98-.8H2.82c-.48 0-.89.33-.98.8L0 10v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8Z"
          fill-rule="evenodd"
        />
      </symbol>
      <symbol id="circle-arrow-down" viewBox="0 0 32 32">
        <path fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" d="m10.5 14.5 5.5 5.6 5.6-5.6" />
        <circle cx="15.9" cy="16" r="14.6" fill="none" stroke="currentColor" stroke-width="2.8" stroke-miterlimit="10" />
      </symbol>
      <symbol id="arrow-down" viewBox="0 0 32 32">
        <path fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" d="m10.4 12.8 5.6 5.6 5.5-5.6" />
      </symbol>
      <symbol id="bin" viewBox="0 0 32 35.3">
        <path
          style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round; stroke-linejoin: round"
          d="M26.2 16.7v10.5c0 3.5-2.8 6.3-6.3 6.3H11c-3.5 0-6.3-2.8-6.3-6.3V11.6M9.4 5.7c0-2.3 1.9-4.2 4.2-4.2h4.7c2.3 0 4.2 1.9 4.2 4.2v4.4M1.6 4.3l28.7 8.8M12 16.2v12.1M18.9 16.2v12.1"
        />
      </symbol>
      <symbol id="course" fill="none" color="currentColor" viewBox="0 0 24 24">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="1.5"
          d="M8.491 16.994C5.847 17.392 4 18.367 4 19.424 4 20.846 7.35 22 11.485 22s7.485-1.154 7.485-2.576c0-1.122-2.083-2.076-4.99-2.43"
        />
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M10.98 19.028c.083-7.174-.197-13.89.171-16.14.28-.796.771-1.593 3.998.175l2.18 1.069c1.342.657 3.21 1.706 2.441 2.987-.35.583-1.145 1.235-2.7 1.897l-6.092 2.968"
        />
      </symbol>
      <symbol id="user" viewBox="0 0 32 35.3">
        <path
          style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round; stroke-linejoin: round"
          d="M3.4 33.5s-1-7.3 4.1-9.7c6.2-2.9 18.1 4.7 21.2 9.9"
        />
        <circle style="fill: none; stroke: currentColor; stroke-width: 2.8; stroke-linecap: round; stroke-linejoin: round" cx="13.8" cy="10" r="8.2" />
      </symbol>
      <symbol id="lock" viewBox="0 0 25.6 34">
        <path style="fill: none; stroke: currentColor; stroke-width: 2.8" d="M6.3 11.2V8.4C6.3 4.9 9.2 2 12.8 2s6.5 2.9 6.5 6.4v6" />
        <path
          style="fill: none; stroke: currentColor; stroke-width: 2.8"
          d="M20.2 32.2H5.4c-1.9 0-3.5-1.4-3.5-3.1V14.3c0-1.7 1.6-3.1 3.5-3.1l14.9 3.1c1.9.5 3.5 1.9 3.5 4.5v10.3c-.1 1.7-1.6 3.1-3.6 3.1z"
        />
        <path fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" d="M12.4 24.8v2.9" />
        <circle cx="12.4" cy="21.1" r="3.2" fill="none" stroke="currentColor" stroke-width="2.8" stroke-miterlimit="10" />
      </symbol>
      <symbol id="check-mark-secondary" viewBox="0 0 8.483 7.495">
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="1.8"
          d="M1.262 4.562l2.163 1.667 3.797-4.967"
          data-name="arrow no circle 32 secondary"
        />
      </symbol>
    </svg>
    <ApiAtom :isLoading="loader !== undefined" :header="loader" :error="error" @dismissError="$emit('dismissError')">
      <div class="sgf-app-shell-atom__layout">
        <slot></slot>
      </div>
    </ApiAtom>
  </div>
</template>

<script>
import ApiAtom from '../atoms/ApiAtom.vue';
export default {
  components: {
    ApiAtom,
  },
  props: {
    configuration: Object,
    error: String,
    loader: String,
  },
  mounted() {
    let r = document.querySelector(':root');
    let { backgroundColor, textColor, primaryColor, secondaryColor, primaryGrayColor, secondaryGrayColor, statusRedColor, statusPinkColor, slotColor } =
      this.configuration;
    r.style.setProperty('--sgf-c-background', backgroundColor ? backgroundColor : '#ffffff');
    r.style.setProperty('--sgf-c-text', textColor ? textColor : '#303030');
    r.style.setProperty('--sgf-c-primary', primaryColor ? primaryColor : '#9dd3ef');
    r.style.setProperty('--sgf-c-secondary', secondaryColor ? secondaryColor : '#e1eff7');
    r.style.setProperty('--sgf-c-primary-gray', primaryGrayColor ? primaryGrayColor : '#6c6c6c');
    r.style.setProperty('--sgf-c-secondary-gray', secondaryGrayColor ? secondaryGrayColor : '#f4f4f4');
    r.style.setProperty('--sgf-c-status-red', statusRedColor ? statusRedColor : '#ce0000');
    r.style.setProperty('--sgf-c-status-pink', statusPinkColor ? statusPinkColor : '#fdf0f0');

    r.style.setProperty('--ace-c-mg-background', backgroundColor ? backgroundColor : '#d1def0');
    r.style.setProperty('--ace-c-mg-primary', primaryColor ? primaryColor : '#eff4ff');
    r.style.setProperty('--ace-c-mg-secondary', secondaryColor ? secondaryColor : '#046294');
    r.style.setProperty('--ace-c-mg-slot', slotColor ? slotColor : '#bdcbdf');
  },
};
</script>
<style>
:root {
  --sgf-c-background: #ffffff;
  --sgf-c-text: #303030;
  --sgf-c-primary: #9dd3ef;
  --sgf-c-secondary: #e1eff7;
  --sgf-c-primary-gray: #6c6c6c;
  --sgf-c-secondary-gray: #f4f4f4;
  --sgf-c-status-pink: #fdf0f0;
  --sgf-c-status-red: #ce0000;
  --sgf-c-status-yellow: #fcf1c3;
  --sgf-c-status-brown: #765001;
  --sgf-c-text-blue: #4d74a2;
}

.sgf-ace div,
.sgf-ace span,
.sgf-ace h1,
.sgf-ace h2,
.sgf-ace h3,
.sgf-ace h4,
.sgf-ace h5,
.sgf-ace h6,
.sgf-ace p,
.sgf-ace pre,
.sgf-ace a,
.sgf-ace img,
.sgf-ace strong,
.sgf-ace sub,
.sgf-ace sup,
.sgf-ace var,
.sgf-ace ol,
.sgf-ace ul,
.sgf-ace li,
.sgf-ace fieldset,
.sgf-ace form,
.sgf-ace label,
.sgf-ace legend,
.sgf-ace table,
.sgf-ace caption,
.sgf-ace tbody,
.sgf-ace tfoot,
.sgf-ace thead,
.sgf-ace tr,
.sgf-ace th,
.sgf-ace td,
.sgf-ace article,
.sgf-ace footer,
.sgf-ace header,
.sgf-ace time {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
.sgf-ace table {
  border-collapse: collapse;
  border-spacing: 0;
}
.sgf-ace :deep(svg) {
  box-sizing: content-box;
}
html body .sgf-ace {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  line-height: 1.7em;
  color: var(--sgf-c-text);
}

html body .sgf-ace input,
html body .sgf-ace select {
  font-size: 16px;
}

.sgf-ace .scroll::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.scroll::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #dddddd;
  background-clip: content-box;
}

.scroll::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: var(--sgf-c-text);
}
.scroll::-webkit-scrollbar-thumb:window-inactive {
  border-radius: 8px;
  background-color: var(--sgf-c-text);
}
.sgf-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  display: block;
  white-space: nowrap;
}
.sgf-ace .sgf-shadow {
  -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
}
</style>
<style scoped>
.sgf-ace.sgf-app-shell-atom {
  background: var(--sgf-c-background);
}

.sgf-ace .sgf-app-shell-atom__layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
}
</style>
